import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=ac647a06&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"
import style0 from "./page2.vue?vue&type=style&index=0&id=ac647a06&lang=scss&scoped=true&"
import style1 from "./page2.vue?vue&type=style&index=1&id=ac647a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac647a06",
  null
  
)

export default component.exports